export const EDITRY_BASE_URL = process.env.REACT_APP_EDITRY_BASE_URL || 'https://admin.lazylabs.cz';
export const EDITRY_PUBLIC_TOKEN = process.env.REACT_APP_EDITRY_PUBLIC_TOKEN || '';

export const EDITRY_CONFIG = {
  baseUrl: EDITRY_BASE_URL,
  editryToken: EDITRY_PUBLIC_TOKEN,
};

export const isEditryConfigured = () => Boolean(EDITRY_PUBLIC_TOKEN);
